import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["teamResolver", "userResolver", "requestsLoading"];
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import HierarchicalTeamReferenceResolver from 'reference-resolvers/resolvers/HierarchicalTeamReferenceResolver';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import AppUserReferenceResolver from 'reference-resolvers/resolvers/AppUserReferenceResolver';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ResolveReferences from 'reference-resolvers/ResolveReferences';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { isError, isLoading } from 'reference-resolvers/utils';
import { APP_USER, HIERARCHICAL_TEAM
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
} from 'reference-resolvers/constants/ReferenceObjectTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const mapReferenceResolverToPlainJS = resolverInstance => {
  if (isError(resolverInstance) || isLoading(resolverInstance)) {
    return [];
  }
  return resolverInstance.toJS().map(item => item.referencedObject);
};
const WithUsersAndTeamsDataFetching = (Component, resolverOptions = {}) => {
  const DataProvider = _ref => {
    let {
        teamResolver,
        userResolver,
        requestsLoading
      } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      users: mapReferenceResolverToPlainJS(userResolver),
      teams: mapReferenceResolverToPlainJS(teamResolver),
      requestsError: isError(teamResolver) || isError(userResolver),
      requestsLoading: requestsLoading || isLoading(teamResolver) || isLoading(userResolver)
    }));
  };
  const mapResolversToProps = resolvers => {
    return {
      userResolver: resolvers[APP_USER].all(),
      teamResolver: resolvers[HIERARCHICAL_TEAM].all()
    };
  };
  return ProvideReferenceResolvers({
    [APP_USER]: AppUserReferenceResolver,
    [HIERARCHICAL_TEAM]: HierarchicalTeamReferenceResolver
  }, ResolveReferences(mapResolversToProps)(DataProvider), resolverOptions);
};
export default WithUsersAndTeamsDataFetching;